import { render, staticRenderFns } from "./KeyVault.vue?vue&type=template&id=1ec7c7a6&scoped=true"
import script from "./KeyVault.vue?vue&type=script&lang=js"
export * from "./KeyVault.vue?vue&type=script&lang=js"
import style0 from "./KeyVault.vue?vue&type=style&index=0&id=1ec7c7a6&prod&lang=css"
import style1 from "./KeyVault.vue?vue&type=style&index=1&id=1ec7c7a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec7c7a6",
  null
  
)

export default component.exports